/** Backend values stay unchanged; customize portal display labels here. */
export const EMPLOYEE_TYPE_LABELS = {
  REGULAR: "Regular",
  CONSULTANT: "Consultant",
  SQELABS: "SQE Labs",
  IVYCLINIC: "Ivy Clinic",
  IVY_CLINIC: "Ivy Clinic",
} as const;

export type EmployeeType = keyof typeof EMPLOYEE_TYPE_LABELS;

export const EMPLOYEE_TYPE_OPTIONS = Object.entries(EMPLOYEE_TYPE_LABELS).map(
  ([value, label]) => ({ value, label }),
);

export function employeeTypeLabel(value?: string | null): string {
  const normalized = value?.trim() ?? "";
  if (!normalized) return "-";
  return EMPLOYEE_TYPE_LABELS[normalized.toUpperCase() as EmployeeType]
    ?? normalized.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}
